import { resolveComponent as _resolveComponent, createVNode as _createVNode, Teleport as _Teleport, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, createSlots as _createSlots, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "m-auto px-8 md:px-20" }
const _hoisted_2 = { class: "max-w-screen-2xl m-auto" }
const _hoisted_3 = { class: "grid grid-cols-4 gap-4 mb-3" }
const _hoisted_4 = { class: "flex flex-col col-span-2" }
const _hoisted_5 = { class: "flex justify-end" }
const _hoisted_6 = { class: "rotate-x-180 overflow-x-scroll" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Loading = _resolveComponent("Loading")!
  const _component_Field = _resolveComponent("Field")!
  const _component_Paginator = _resolveComponent("Paginator")!
  const _component_NextTable = _resolveComponent("NextTable")!
  const _component_InfiniteLoading = _resolveComponent("InfiniteLoading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_openBlock(), _createBlock(_Teleport, { to: "#modal" }, [
      _createVNode(_component_Loading, {
        visible: _ctx.lista.loading
      }, null, 8, ["visible"])
    ])),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _cache[3] || (_cache[3] = _createElementVNode("div", { class: "py-5 text-2xl font-bold" }, " Lista Permessi ", -1)),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_Field, {
              field_name: "Cerca",
              "onUpdate:modelValue": [
                _ctx.lista.debounceSearch,
                _cache[0] || (_cache[0] = ($event: any) => ((_ctx.lista.search) = $event))
              ],
              modelValue: _ctx.lista.search,
              placeholder: "Cerca"
            }, null, 8, ["onUpdate:modelValue", "modelValue"])
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_Paginator, {
            class: "",
            pagination: _ctx.lista.paginate
          }, null, 8, ["pagination"])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_NextTable, {
            class: "rotate-x-180 table-auto w-full border-separate border-spacing-3 py-4",
            cols: _ctx.cols,
            "onUpdate:cols": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.cols) = $event)),
            rows: _ctx.lista.rows,
            onOrderUpdate: _ctx.lista.updateCols
          }, _createSlots({ _: 2 }, [
            _renderList(_ctx.lista.rows, (c, j) => {
              return {
                name: `td_${j}_1`,
                fn: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$filters.toDateTime(c.created_at)), 1)
                ])
              }
            }),
            _renderList(_ctx.lista.rows, (c, j) => {
              return {
                name: `td_${j}_2`,
                fn: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$filters.toDateTime(c.deleted_at)), 1)
                ])
              }
            })
          ]), 1032, ["cols", "rows", "onOrderUpdate"])
        ]),
        _createVNode(_component_InfiniteLoading, {
          onInfinite: _ctx.lista.fetchNextPage,
          identifier: _ctx.lista.infiniteIdentifier,
          style: {"min-height":"1px"}
        }, {
          complete: _withCtx(() => _cache[2] || (_cache[2] = [
            _createElementVNode("div", { class: "text-center pb-3" }, "Non ci sono altri utenti.", -1)
          ])),
          _: 1
        }, 8, ["onInfinite", "identifier"])
      ])
    ])
  ], 64))
}